import { useQuery } from "react-query";
import { getCarrierNameLists } from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";

export const useGetCarrierNameLists = () => {
  return useQuery("GetCarrierNameList", getCarrierNameLists, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
